import {LiveAll} from '@/components/main/live/all/LiveAll';

export default function Live() {
  try {
    return <LiveAll />;
  } catch (error) {}
}
